import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../../common/EnhancedTableHead';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconColumn: { 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center' 
    }
  })
);

interface Props {
  actions: any[];
}

const headRows: HeadRow[] = [
  { id: 'assignedToCurrentUser', disablePadding: false, label: 'Assigned' },
  { id: 'description', disablePadding: false, label: 'Approval Description' },
  { id: 'approvalDecision', disablePadding: false, label: 'Approval Decision' },
  { id: 'groups', disablePadding: false, label: 'Valid Approver Groups' },
  { id: 'approver', disablePadding: false, label: 'Approver' },
  { id: 'timestamp', disablePadding: false, label: 'Approval Time' }
];

function ApprovalsTable(props: Props) {
  const classes = useStyles({});
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('assignedToCurrentUser');

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const sortedRows = sortRows(props.actions, getSorting(order, orderBy));

  return (
    <Table>
      <EnhancedTableHead
        order={order}
        orderBy={orderBy}
        fields={headRows}
        onRequestSort={handleRequestSort}
      />
      <TableBody>
        {sortedRows.map(row => (
          <TableRow key={row.id}>
            <TableCell>
              <div className={classes.iconColumn}>
                {row.assignedToCurrentUser && <CheckIcon color="primary" />}
              </div>
            </TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>{row.approvalDecision || 'PENDING'}</TableCell>
            <TableCell>{row.groups}</TableCell>
            <TableCell>{row.approver || 'None'}</TableCell>
            <TableCell>
              {row.timestamp ? <Tooltip title={`${moment(row.timestamp).format('ddd, MMM Do YYYY, HH:mm z')} ${moment.tz.zone(moment.tz.guess()).abbr(row.timestamp)}`}>
                <Typography>{moment(row.timestamp).fromNow()}</Typography>
              </Tooltip> : 'None'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ApprovalsTable;
